import SceneManager from "../../manager/scene_manager";
import SdkBase from "./sdk_base";
import SdkDefine from "./sdk_define";
import AppController from "../app_controller";
import AppData from "../../pacakge/public/const/app_data";
import Utility from "../../utility/utility";


export default class SdkLine extends SdkBase {

    private static _instance: SdkLine;
    public static get instance(): SdkLine {

        if (!SdkLine._instance) {

            SdkLine._instance = new SdkLine();
        }
        return SdkLine._instance;
    }

    constructor() {
        super(SdkDefine.LINE_NAME);
    }

    public receive(json: any, callback?) {
        if (json.funcName == "login") {
            this.login(json.param, callback);
        }
    }

    public login(jsonParam: string, callback?) {

        let param = jsonParam;

        cc.log(" line login  : " + param);

        let jsonObject = JSON.parse(jsonParam);
        jsonObject["deviceId"] = AppData.devicesId;

        if (this.checkLogin(jsonParam)) {
            param = JSON.stringify(jsonObject);
            cc.log(" line login  : " + param );
            Utility.reportEffect("login_lineLoginCb")
            if (callback != null) {
                callback(param)
                callback = null
            } else {
                SceneManager.loginFromAuth(param);
            }
        } else {
            Utility.reportEffect("login_lineLoginCb_error", jsonObject.error)
        }
    }

}
